export const wspace = {
   namespaced: true,
   state: {
      cellName: "",
      contentId: 0,
      closeComment: false,
      clickDivComment: false,
      offCanvasOpen: 0,
      sortParameters: [],
      filterCardTypeId: 0,
      filterUserId: 0,
      filterLabelId: 0,
      filterParameters: {
         onOff: false,
         cardTypeId: 0,
         userId: 0,
         labelId: 0,
      },
      draftNotification: ""
   },
   actions: {
      updateDraftNotification( { commit }, draft ) {
         if ( draft != null ) {
            commit( 'updateDraftNotification', draft )
         }
      },
      onOffFilter({ commit }) {
         commit('onOffFilter');
      },
      updateFilterCardTypeId({ commit }, cardTypeId) {
         if (cardTypeId != null) {
            commit('updateCardTypeId', cardTypeId);
         }
      },
      updateFilterUserId({ commit }, userId) {
         if (userId != null) {
            commit('updateFilterUserId', userId);
         }
      },
      updateFilterLabelId({ commit }, labelId) {
         if (labelId != null) {
            commit('updateFilterLabelId', labelId);
         }
      },
      updateSortParam({ commit, state }, sortParam) {
         let sortParamIndex = state.sortParameters.findIndex((obj => obj.cellId === sortParam.cellId));
         if (sortParamIndex >= 0) {
            commit('updateSortParam', {sortParamIndex, sortParam});
         } else {
            commit('addSortParam', sortParam);
         }
      },
      setOffCanvas({ commit }, canvasOpen) {
         commit('setOffCanvas', canvasOpen);
      },
      setCellName({ commit }, cellName) {
         commit('setCellName', cellName);
      },
      setContentId({ commit }, contentId) {
         commit('setContentId', contentId);
      },
      setCloseComment({ commit }, _boolean) {
         commit('setCloseComment', _boolean);
      },
      setClickDivComment({ commit }, _boolean) {
         commit('setClickDivComment', _boolean);
      },
   },
   mutations: {
      //commit( 'updateDraftNotification', draft )
      updateDraftNotification( state, draft ) {
         state.updateDraftNotification = draft
      },
      onOffFilter(state) {
         state.filterParameters.onOff = !state.filterParameters.onOff;
       },
      updateCardTypeId(state, cardTypeId) {
         state.filterCardTypeId = cardTypeId;
       },
       updateFilterUserId(state, userId) {
         //state.filterParameters.userId = userId;
         state.filterUserId = userId;
       },
       updateFilterLabelId(state, labelId) {
         //state.filterParameters.labelId = labelId;
         state.filterLabelId = labelId;
       },
       updateSortParam(state, {sortParamIndex, sortParam}) {
         state.sortParameters[sortParamIndex].field = sortParam.field;
         state.sortParameters[sortParamIndex].order = sortParam.order;
      },
      addSortParam(state, sortParam) {
         state.sortParameters = [sortParam,...state.sortParameters];
      },
      setOffCanvas(state, canvasOpen) {
        state.offCanvasOpen = canvasOpen;
      },
      setCellName(state, cellName) {
         state.cellName = cellName;
      },
      setContentId(state, contentId) {
        state.contentId = contentId;
      },
      setCloseComment(state, _boolean) {
        state.closeComment = _boolean;
      },
      setClickDivComment(state, _boolean) {
        state.clickDivComment = _boolean;
      },
   }
};
 